<template>
  <div>
    <!-- <featured /> -->
    <find-car ref="find-car"/>
    <!-- <coming-soon ref="coming-soon"></coming-soon> -->
    <in-shop ref="in-shop"></in-shop>
    <find-us ref="find-us" />
  </div>
</template>

<script>

// import Featured from '../components/Featured.vue'
import FindCar from '../components/FindCar.vue'
// import ComingSoon from '../components/ComingSoon.vue'
import InShop from '../components/InShop.vue'
import FindUs from "../components/FindUs.vue";

export default {
  components: { FindCar, InShop, FindUs },

  methods: {

    scrollTo(target) {
      this.$vuetify.goTo(this.$refs[target])
    }
  },
};
</script>